import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { EMPTY_VALUE } from '../../../utils/common'
import { selectMaxDate } from '../store/slice'
import { getMaxDate } from '../store/thunk'

const LeftBar = () => {
  const dispatch = useDispatch()
  const settingParams = useSettingParams()

  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const maxDate = useSelector(selectMaxDate)

  useEffect(() => {
    if (!settingParams) return
    dispatch(getMaxDate(settingParams))
  }, [settingParams])

  const formatMaxDate = () => {
    if (!Object.keys(maxDate).length) return EMPTY_VALUE
    const { year, month, day } = maxDate
    return formatDateTime(
      new Date(year, month - 1, day),
      FORMAT.DATE,
      locale,
      timezone,
    )
  }

  return (
    <div className="fw600">
      <Translate value={'portfolio.segment.LAST_UPDATE_DATE'} />
      {formatMaxDate()}
    </div>
  )
}

export default LeftBar
